import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditEvaluationType extends TermCreateEdit {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "evaluation_type";
  }
}
